import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import styles from './Spinner.module.scss';
export type SpinnerSize = 'sm' | 'md' | 'lg';
export type SpinnerVariant = 'default' | 'brand' | 'white';
export interface SpinnerProps {
  size?: SpinnerSize;
  variant?: SpinnerVariant;
  label?: string;
}
const BLADES = Array.from({
  length: 12
});
function Spinner(t0) {
  const $ = _c(7);
  const {
    size: t1,
    variant: t2,
    label: t3
  } = t0;
  const size = t1 === undefined ? "md" : t1;
  const variant = t2 === undefined ? "default" : t2;
  const label = t3 === undefined ? "Loading" : t3;
  const t4 = styles[`helios-spinner--${size}`];
  const t5 = styles[`helios-spinner--${variant}`];
  let t6;
  if ($[0] !== t4 || $[1] !== t5) {
    t6 = classNames(styles["helios-spinner"], styles["helios-spinner--animating"], t4, t5);
    $[0] = t4;
    $[1] = t5;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  let t7;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = BLADES.map(_temp);
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] !== label || $[5] !== t6) {
    t8 = <div role="status" aria-label={label} className={t6}>{t7}</div>;
    $[4] = label;
    $[5] = t6;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  return t8;
}
function _temp(_, i) {
  return <div key={i} className={styles["helios-spinner__blade"]} />;
}
export default Spinner;